module.exports = __webpack_public_path__ + "media/recommendations.93df75c9.webm";